<div class="doNotPrint">
  <div class="p-3 d-flex gap-3">
    <div class="form-floating">
      <input type="number" class="form-control" id="amount" name="amount" placeholder="Settlement Amount" [(ngModel)]="amount" required autoSelect />
      <label for="amount">Settlement Amount</label>
    </div>
    <app-select-business-license class="flex-fill" customLabel="Header Business" [businessOnly]="true" [(businessId)]="headerBusinessId"></app-select-business-license>
    <mat-form-field class="flex-fill" subscriptSizing="dynamic">
      <mat-label>Header Address</mat-label>
      <mat-select [(ngModel)]="license" required>
      @for (l of businessLicenseList(); track l.Id) {
        <mat-option [value]="l">{{ l.FullAddress }}</mat-option>
      }
      </mat-select>
    </mat-form-field>
    <app-select-business-license class="flex-fill" customLabel="Business" [businessOnly]="true" [(businessId)]="businessId"></app-select-business-license>
    <mat-form-field class="flex-fill" subscriptSizing="dynamic">
      <mat-label>Finance Account</mat-label>
      <mat-select [(ngModel)]="financeAccount" required>
      <mat-select-trigger>{{ financeAccount()?.Description }}</mat-select-trigger>
    @for (f of businessFaList(); track f.Id) {
      <mat-option class="p-2" [value]="f">
        <div class="d-flex gap-1">
          <img [src]="getBankLogoByName(f.Bank)" style="max-height: 48px; width: 48px;">
          <div class="flex-fill">
            <div class="fw-semibold">{{ f.Code }} {{ f.AccNumber }}</div>
            <div class="text-secondary">{{ f.Description }}</div>
          </div>
        </div>
      </mat-option>
    }
      </mat-select>
    </mat-form-field>
    <!-- <app-select-finance-accounts class="flex-fill" [faSelectionList]="businessFaList()" [(selectedFa)]="financeAccount"></app-select-finance-accounts> -->
    <div class="d-flex gap-1">
      <button class="btn btn-outline-primary" (click)="reset()">Reset</button>
      <button class="btn btn-primary" [style.visibility]="amount() > 0 && headerBusiness() && license() && financeAccount() ? 'visible' : 'hidden'" (click)="print()">Print</button>
    </div>
  </div>
  <hr>
</div>
@if (headerBusiness() && license() && financeAccount()) {
<div class="text-justify print-area" id="htmlData" #htmlData>
  <div class="fw-bold">
    <div class="text-center mb-4">
      <div class="fs-20">{{ headerBusiness().Name }} <span class="fs-10">({{ headerBusiness().OldRegNo }})</span></div>
      <div class="w-50 mx-auto">{{ license().AddressInTwoLines }}</div>
    </div>
    <hr>
    <p class="text-end text-uppercase mt-4">{{ today | date: 'dd MMM yyyy'}}</p>
    <div>Tuan / Puan,</div>
    <br>
    <br>
    <br>
    <p class="fs-14 text-uppercase border-dark border-bottom">Pembayaran balik baki pinjaman</p>
  </div>
  <p>Adalah saya dengan hormatnya merujuk kepada perkara di atas.</p>
  <p>Berikut adalah baki pinjaman untuk:-</p>
  <table class="table text-center table-bordered border-dark fw-bold my-4">
    <tbody>
      <tr>
        <td>Nama</td>
        <td>No K/P</td>
        <td>Baki Pinjaman</td>
      </tr>
      <tr>
        <td>{{ customerName() }}</td>
        <td>{{ customerIc() }}</td>
        <td>{{ amount() | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</td>
      </tr>
    </tbody>
  </table>
  <p>Untuk melunaskan baki pinjaman tersebut, berikut disertakan maklumat bank syarikat kami untuk tindakan TUAN/PUAN selanjutnya.</p>
  <div class="grid-3-col column-gap-2 fit-width justify-content-center fst-italic my-4 w-auto mx-auto"  style="min-width: 75%;">
    <div>Nama Syrkt</div>
    <div class="fst-normal">:</div>
    <div class="fw-bold">{{ business().Name }}</div>
    <div>Bank</div>
    <div class="fst-normal">:</div>
    <div class="fw-bold">{{ financeAccount().Bank }}</div>
    <div>No Akaun</div>
    <div class="fst-normal">:</div>
    <div class="fw-bold">{{ financeAccount().AccNumber }}</div>
    <div>Jumlah</div>
    <div class="fst-normal">:</div>
    <div class="fw-bold">{{ amount() | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</div>
  </div>
  <p>Segala kerjasama pihak Tuan kami dahului dengan ucapan ribuan terima kasih.</p>
  <br>
  <p>Sekian.</p>
  <br>
  <p>Yang benar,</p>
  <br>
  <br>
  <br>
  <br>
  <div class="fw-bold">{{ financeAccount().Directors }}</div>
  <div class="fw-bold">Pengarah</div>
</div>
}
<div class="doNotPrint">
  <div class="my-4">&nbsp;</div>
</div>